<template functional>
	<div class="pdp-title">
		<div class="pdp-header">
			<a :href="'/brands/' + props.product.brandUrl + '/'" class="pdp-brand">
				{{ props.product.brand }}<span class="visually-hidden">&nbsp;brand page</span>
			</a>
			{{ props.product.name }}
		</div>
		<div class="pdp-blain-mfg">
			Blain # {{ props.product.blainNumber }} | Mfr # {{ props.product.mfgItemNumber }}
		</div>
	</div>
</template>

<script>
export default {
	name: "ProductTitle",
	props: {
		product: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang='less' scoped>

.pdp-brand {
    color: #666;
    font-size: 16px;
    display: block;
    text-decoration: none;

    &:hover,
    &:focus {
        text-decoration: underline;
    }
}
</style>